import React from "react";
import './PopUpMainHeading.css';

const PopUpMainHeading = ({content,color}) =>{
    return (
        <span className={`pop-up-main-heading ${color} ? color : ''`}>{content}</span>
    )
}
export default PopUpMainHeading;